export var filterAutoCompleteValues = function filterAutoCompleteValues(data, autoCompleteFilterKey, filterValue, shouldFilterOnAllFields, hideAutoCompleteOnFilterSelection) {
  if (shouldFilterOnAllFields === void 0) {
    shouldFilterOnAllFields = false;
  }
  if (hideAutoCompleteOnFilterSelection === void 0) {
    hideAutoCompleteOnFilterSelection = false;
  }
  var filterValueLowerCase = filterValue === null || filterValue === void 0 ? void 0 : filterValue.toLowerCase();
  if (shouldFilterOnAllFields) {
    return data === null || data === void 0 ? void 0 : data.filter(listItem => _iterateObject(listItem, filterValueLowerCase, hideAutoCompleteOnFilterSelection));
  }
  return data === null || data === void 0 ? void 0 : data.filter(listItem => {
    var _a, _b;
    return (_b = (_a = listItem[autoCompleteFilterKey]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(filterValueLowerCase);
  });
};
var _iterateObject = function iterateObject(listItem, filterValue, hideAutoCompleteOnFilterSelection) {
  if (hideAutoCompleteOnFilterSelection === void 0) {
    hideAutoCompleteOnFilterSelection = false;
  }
  var _a;
  return (_a = Object.values(listItem)) === null || _a === void 0 ? void 0 : _a.some(val => {
    var _a, _b;
    var typeOfVal = typeof val;
    if (typeOfVal === 'string' || typeOfVal === 'number' || typeOfVal === 'boolean') {
      if (hideAutoCompleteOnFilterSelection && filterValue === val) {
        return false;
      }
      return (_b = (_a = "" + val) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(filterValue);
    } else return _iterateObject(val, filterValue);
  });
};
export { _iterateObject as iterateObject };